import { render, staticRenderFns } from "./GetUserByRegion.vue?vue&type=template&id=6266b45d&"
import script from "./GetUserByRegion.vue?vue&type=script&lang=js&"
export * from "./GetUserByRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports